// extracted by mini-css-extract-plugin
export default {"fullWidth":"bp-z","image":"cp-z","lazyLoadPicture":"dp-z","lazyLoadSpinner":"ep-z","lazyLoadSpin":"fp-z","lazyLoadImage":"gp-z","hasStyledAspectRatio":"hp-z"};